import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-label',
    templateUrl: './modal-label.component.html',
    styleUrls: ['./modal-label.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalLabelComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalLabelComponent>>(MatDialogRef);

    modalTitle = '';
    content = '';
    cancel = '';
    confirm = '';
    currentLabel = '';
    etape_id = '';

    public form: UntypedFormGroup;
    public formSubmitAttempt: boolean;

    constructor() {
        const data = this.data;

        if (
            data != undefined &&
            data.modalTitle != undefined &&
            data.modalTitle != ''
        )
            {this.modalTitle = data.modalTitle;}
        if (
            data != undefined &&
            data.content != undefined &&
            data.content != ''
        )
            {this.content = data.content;}
        if (data != undefined && data.cancel != undefined && data.cancel != '')
            {this.cancel = data.cancel;}
        if (
            data != undefined &&
            data.confirm != undefined &&
            data.confirm != ''
        )
            {this.confirm = data.confirm;}
        this.currentLabel =
            data != undefined && data.item != undefined && data.item != ''
                ? data.item.label
                : '';
        this.etape_id =
            data != undefined &&
            data.etape_id != undefined &&
            data.etape_id != ''
                ? data.etape_id
                : null;
    }

    // ---------------------------------------------------
    // CREATE FORM
    //
    createForm() {
        this.form = new UntypedFormGroup({
            label: new UntypedFormControl(this.currentLabel, [Validators.required]),
        });
    }

    get label() {
        return this.form.get('label');
    }

    // ---------------------------------------------------
    // SAVE LABEL
    //
    prepareForSave() {
        this.formSubmitAttempt = true;
        if (this.form.valid) {
            const data = {
                label: this.label.value,
                etape_id: this.etape_id,
            };
            this.dialogRef.close(data);
        }
    }

    // ---------------------------------------------------
    // CANCEL FORM
    //
    public cancelForm() {
        this.formSubmitAttempt = false;
    }

    // ---------------------------------------------------
    // INIT
    //
    ngOnInit() {
        this.createForm();
    }
}
